/*
 * Copyright (C) 2018 - 2026 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import {
  SunOutlined,
  RiseOutlined,
  MoonOutlined,
  DashboardOutlined,
} from '@ant-design/icons';

/**
 * Register codes
 */
export const TOTAL_IMPORT_CODES = ['1.8.8', '1.8.0*01_0', '1.8.0_0'];

export const TOTAL_EXPORT_CODES = ['2.8.0', '2.8.0*01_0', '2.8.0_0'];

export const ACTIVE_IMPORT_CODES = [
  '1.8.1',
  '1.8.1*01_0',
  '1.8.1_0',
  '1.8.2',
  '1.8.2*01_0',
  '1.8.2_0',
  '1.8.3',
  '1.8.3*01_0',
  '1.8.3_0',
];

export const ACTIVE_EXPORT_CODES = [
  '2.8.1',
  '2.8.1*01_0',
  '2.8.1_0',
  '2.8.2',
  '2.8.2*01_0',
  '2.8.2_0',
  '2.8.3',
  '2.8.3*01_0',
  '2.8.3_0',
];

export const MAXIMUM_DEMAND_CODES = ['9.6.0', '9.6.0*01_0', '9.6.0_0'];

/**
 * Energy sections configuration
 */
export const ENERGY_SECTIONS = {
  activeImportSections: [
    {
      icon: SunOutlined,
      title: 'label_day_time_import',
      code: '1.8.1',
      type: 'dayTimeImport',
    },
    {
      icon: RiseOutlined,
      title: 'label_peak_time_import',
      code: '1.8.2',
      type: 'peakTimeImport',
    },
    {
      icon: MoonOutlined,
      title: 'label_off_peak_time_import',
      code: '1.8.3',
      type: 'offPeakTimeImport',
    },
  ],

  activeExportSections: [
    {
      icon: SunOutlined,
      title: 'label_day_time_export',
      code: '2.8.1',
      type: 'dayTimeExport',
    },
    {
      icon: RiseOutlined,
      title: 'label_peak_time_export',
      code: '2.8.2',
      type: 'peakTimeExport',
    },
    {
      icon: MoonOutlined,
      title: 'label_off_peak_time_export',
      code: '2.8.3',
      type: 'offPeakTimeExport',
    },
  ],

  bulkImportSections: [
    {
      icon: SunOutlined,
      title: 'label_day_time_import',
      code: '1.8.1',
      type: 'dayTimeImport',
    },
    {
      icon: RiseOutlined,
      title: 'label_peak_time_import',
      code: '1.8.2',
      type: 'peakTimeImport',
    },
    {
      icon: MoonOutlined,
      title: 'label_off_peak_time_import',
      code: '1.8.3',
      type: 'offPeakTimeImport',
    },
    {
      icon: DashboardOutlined,
      title: 'label_max_demand',
      code: '9.6.0',
      type: 'maximumDemand',
    },
  ],

  bulkExportSections: [
    {
      icon: SunOutlined,
      title: 'label_day_time_export',
      code: '2.8.1',
      type: 'dayTimeExport',
    },
    {
      icon: RiseOutlined,
      title: 'label_peak_time_export',
      code: '2.8.2',
      type: 'peakTimeExport',
    },
    {
      icon: MoonOutlined,
      title: 'label_off_peak_time_export',
      code: '2.8.3',
      type: 'offPeakTimeExport',
    },
  ],
};
